<template>
  <section class="location">
    <Header />
    <Nav :isInLocation="true"
         @goToLocation="goToLocation"
         @goToBase="goToBase"/>
    <div class="container">
      <div class="row">
        <div class="location__title-wrapper">
          <div class="location__title minor__title">Ветровой район</div>
        </div>
        <div class="location__pane common__pane">
          <div class="location__pane-title common__title">
            Карта районирования территории РФ по давлению ветра
          </div>
          <div class="location__pane-map">
            <Yamap  @setZoneParams="setZoneParams"/>
          </div>
          <div class="location__pane-inputs">
            <div class="location__pane-inputs--zone">
              <div class="title">
                Ветровой район
              </div>
              <div class="select"
                   :class="{'active': isShowOptions}">
                <div @click="isShowOptions = !isShowOptions"
                     class="select__box">
                  {{ location.zone }}
                  <div class="select__btn">
                    <svg width="10"
                         :height="isShowOptions ? 6 : 12"
                         :viewBox="isShowOptions ? '0 0 10 6' : '0 0 10 12'"
                         :opacity="isShowOptions ? 0.5 : 1"
                         fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path :d="path" fill="#E30713"></path>
                    </svg>
                  </div>
                </div>
                <div class="options" v-if="isShowOptions">
                  <label :for="`district-${item.name}`"
                         v-for="item in filteredDistricts"
                         :key="item.id">
                    <input type="radio"
                           v-model="location.zone"
                           :value="item.name"
                           :id="`district-${item.name}`"
                           @change="updateZone">
                    <span class="name">{{ item.name }}</span>
                    <span class="pin" :style="{'background': item.pin}"></span>
                  </label>
                </div>
              </div>
              <span class="tooltip__btn">
                <v-popover
                  offset="5"
                  placement="top"
                  trigger="hover">
                  <img src="@/assets/img/question.svg" alt="?">
                  <template slot="popover">
                    <span>{{ this.zone }}</span>
                  </template>
                </v-popover>
              </span>
            </div>
            <span class="divider"></span>
            <div class="location__pane-inputs--pressure">
              <div class="title">
                Расчетное ветровое давление
              </div>
              <div class="input">{{ location.pressure }}</div>
              <div class="title">
                кПа
              </div>
              <span class="tooltip__btn">
                <v-popover
                  offset="5"
                  placement="top"
                  trigger="hover">
                  <img src="@/assets/img/question.svg" alt="?">
                  <template slot="popover">
                    <span>{{ this.pressure }}</span>
                  </template>
                </v-popover>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="location__title-wrapper">
          <div class="location__title minor__title location__title-types">Тип местности</div>
        </div>
        <div class="location__types-wrapper">
          <label :for="`type-${item.name}`"
                 v-for="(item, i) in types"
                 class="location__types-item"
                 :class="{'active': location.type === item.name}"
                 :key="`type-${i}`">
            <input type="radio"
                   v-model="location.type"
                   :value="item.name"
                   :id="`type-${item.name}`"
                   @change="updateType">
            <span class="location__types-item--img">
              <img :src="item.src" :alt="item.name">
            </span>
            <span class="location__types-item--name">тип
              <span class="location__types-item--name__h">местности</span> {{ item.name }}
              <span class="btn"
                    :class="{'active': location.type === item.name}">
                <img src="@/assets/img/mobile-tick.svg"
                     v-if="location.type === item.name"
                     alt="✓">
                <span v-text="location.type === item.name ? 'выбрано' : 'выбрать'"></span>
              </span>
            </span>
            <span class="location__types-item--text">{{item.text}}</span>
          </label>
        </div>
        <div class="common__pane coefficient__pane">
          <div class="location__coefficient">
            <div class="location__pane-title location__coefficient-title">
              Коэффициент надежности по ветровой нагрузке
              <span class="tooltip__btn">
                <v-popover
                  offset="5"
                  placement="top"
                  trigger="hover">
                  <img src="@/assets/img/question.svg" alt="?">
                  <template slot="popover">
                    <span>{{ this.coefficient }}</span>
                  </template>
                </v-popover>
              </span>
            </div>
            <input type="number"
                   v-model.number="location.coefficient"
                   class="location__coefficient-input"
                   @change="updateCoefficient">
          </div>
        </div>
        <div class="buttons__nav location__buttons-nav">
          <button @click="goToWizard()"
                  class="common__button-next"
                  :disabled="location.zone === null
                || location.pressure === ''
                || location.type === null
                || location.coefficient === ''">
            Основание кровли
            <img src="@/assets/img/common-arrow-next.svg" alt="→">
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { dataLayerPushEvent } from '@/utils/GTM';
import Header from '@/components/Header.vue';
import Nav from '@/components/Nav.vue';
import Yamap from '@/components/Yamap.vue';

export default {
  data() {
    return {
      isShowOptions: false,
      zone: 'Ветровые районы принимаются по карте 2, приложения Е СП 20.13330.2016',
      pressure: 'Нормативные значения ветрового давления принимаются в зависимости от ветрового района по таблице 11.1 СП 20.13330.2016',
      coefficient: 'Коэффициент надежности по ветровой нагрузке для основной и пиковой ветровых нагрузок следует принимать равным 1,4, согласно СП 20.13330.2016 п. 11',
      districts: [
        {
          id: 0,
          name: '1a',
          pressure: 0.17,
          pin: 'rgba(83, 167, 0, 0.4)',
        },
        {
          id: 1,
          name: '1',
          pressure: 0.23,
          pin: 'rgba(173, 255, 0, 0.4)',
        },
        {
          id: 2,
          name: '2',
          pressure: 0.3,
          pin: 'rgba(71, 250, 143, 0.4)',
        },
        {
          id: 3,
          name: '3',
          pressure: 0.38,
          pin: 'rgba(255, 251, 157, 0.4)',
        },
        {
          id: 4,
          name: '4',
          pressure: 0.48,
          pin: 'rgba(253, 162, 54, 0.4)',
        },
        {
          id: 5,
          name: '5',
          pressure: 0.6,
          pin: 'rgba(255, 67, 7, 0.4)',
        },
        {
          id: 6,
          name: '6',
          pressure: 0.73,
          pin: 'rgba(158, 54, 53, 0.4)',
        },
        {
          id: 7,
          name: '7',
          pressure: 0.85,
          pin: 'rgba(128, 7, 138, 0.4)',
        },
      ],
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      types: [
        {
          name: 'A',
          src: require('@/assets/img/A.jpg'),
          text: 'открытые побережья морей, озер и водохранилищ, сельские местности, в том числе с постройками высотой менее 10 м, пустыни, степи, лесостепи, тундра',
        },
        {
          name: 'B',
          src: require('@/assets/img/B.jpg'),
          text: 'городские территории, лесные массивы и другие местности, равномерно покрытые препятствиями высотой более 10м;',
        },
        {
          name: 'C',
          src: require('@/assets/img/C.jpg'),
          text: 'городские районы с плотной застройкой зданиями высотой более 25 м.',
        },
      ],
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    };
  },
  components: {
    Header,
    Nav,
    Yamap,
  },
  methods: {
    ...mapMutations({
      UPDATE_LOCATION_PARAM: 'UPDATE_LOCATION_PARAM',
      CLEAR_ALL_SECTORS_MATERIAL_SIZE_PARAMS: 'CLEAR_ALL_SECTORS_MATERIAL_SIZE_PARAMS',
    }),
    ...mapActions({
      fetchData: 'fetchData',
    }),
    updateZone() {
      this.UPDATE_LOCATION_PARAM({
        param: 'zone',
        val: this.location.zone,
      });
      this.isShowOptions = false;
      this.updatePressure();
      this.CLEAR_ALL_SECTORS_MATERIAL_SIZE_PARAMS();
    },
    updatePressure() {
      this.UPDATE_LOCATION_PARAM({
        param: 'pressure',
        val: this.findPressure(this.location.zone).pressure,
      });
    },
    updateType() {
      this.UPDATE_LOCATION_PARAM({
        param: 'type',
        val: this.location.type,
      });
      this.CLEAR_ALL_SECTORS_MATERIAL_SIZE_PARAMS();
    },
    updateCoefficient() {
      this.UPDATE_LOCATION_PARAM({
        param: 'coefficient',
        val: this.location.coefficient,
      });
      this.CLEAR_ALL_SECTORS_MATERIAL_SIZE_PARAMS();
    },
    goToWizard() {
      dataLayerPushEvent('calc-roofload-step2');
      this.$router.push('/wizard/0');
    },
    goToLocation() {
      this.$router.push('/location');
    },
    goToBase() {
      this.$router.push('/wizard/0');
    },
    setZoneParams(data) {
      this.UPDATE_LOCATION_PARAM({
        param: 'zone',
        val: data.zone,
      });
      this.isShowOptions = false;
      this.UPDATE_LOCATION_PARAM({
        param: 'pressure',
        val: data.pressure,
      });
    },
    findPressure(name) {
      return this.districts[this.districts.findIndex(p => p.name === name)];
    },
  },
  mounted() {
    if (this.materials.length === 0) {
      this.fetchData();
    }
  },
  computed: {
    ...mapState({
      location: state => state.location,
      materials: state => state.materials,
    }),
    filteredDistricts() {
      return this.districts.filter(district => district.name !== this.location.zone);
    },
    path() {
      return this.isShowOptions ? `M5.78346 5.67606C5.36996 6.10817 4.62393 6.10795 4.21076
                    5.67559L0.251111 1.5322C-0.324408 0.929973 0.153007 0 1.03769 0H8.96231C9.84732
                    0 10.3246 0.930565 9.74844 1.53267L5.78346 5.67606Z` : `M0 0H10V2H0V0Z
                    M0 5H10V7H0V5Z M0 10H10V12H0V10Z`;
    },
  },
};
</script>
<style lang="sass">
.coefficient
  &__pane
    +media((padding: (320: rem(24), 992: rem(40))))
.location
  &__title
    &-wrapper
      width: 100%
    &-types
      +media((padding: (320: rem(40) rem(24) rem(16), 992: rem(51) 0)))
  &__pane
    color: $black
    &-title
      +media((padding-bottom: (320: rem(16), 768: rem(34))))
    &-map
      line-height: 0
      +media((padding-bottom: (320: 0, 768: rem(34))))
      +media((margin: (320: 0 rem(-24), 768: 0)))
      +media((width: (320: calc(100% + 48px), 768: 100%)))
    &-inputs
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      +media((padding: (320: 0, 768: 0 rem(24), 900: 0 rem(50), 960: 0 rem(94))))
      flex-wrap: wrap
      &--zone, &--pressure
        display: flex
        flex-direction: row
        align-items: center
        text-align: left
        +media((padding: (320: rem(12) 0, 992: 0)))
        +media((width: (320: 100%, 768: auto)))
        .title
          font-style: normal
          font-weight: 500
          font-size: rem(14)
          line-height: rem(20)
        .select
          background: #FFFFFF
          border: rem(1) solid $grey
          box-sizing: border-box
          border-radius: rem(4)
          width: rem(80)
          height: rem(34)
          font-style: normal
          font-weight: bold
          font-size: rem(18)
          line-height: rem(22)
          position: relative
          transition: .5s
          cursor: pointer
          margin-left: rem(17)
          margin-right: rem(14)
          &__box
            width: 100%
            display: flex
            flex-direction: row
            align-items: center
            justify-content: space-between
            padding: 0 rem(13) 0 rem(16)
            height: rem(34)
          &.active
            border-radius: 0 0 rem(4) rem(4)
            border-top-color: transparent
            color: rgba(51, 51, 51, 0.2)
            &:hover
              border-color: $grey
              box-shadow: none
          &:hover
            @extend .common__input-hover
            img
              opacity: .5
          &__btn
            display: flex
            flex-direction: row
            align-items: center
            path
              transition: .5s
        .options
          color: $black
          display: flex
          flex-direction: column
          background: #FFFFFF
          z-index: 3
          border: rem(1) solid $grey
          border-bottom: 0
          border-radius: rem(4) rem(4) 0 0
          // border: rem(1) solid #ECECEC
          //box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.15)
          width: rem(80)
          position: absolute
          left: rem(-1)
          bottom: 100%
          label
            position: relative
            font-style: normal
            font-weight: bold
            font-size: rem(18)
            line-height: rem(22)
            opacity: 0.9
            text-align: left
            height: rem(34)
            box-shadow: inset 0 rem(-1) 0 #ECECEC
            display: flex
            flex-direction: row
            align-items: center
            padding-left: rem(14)
            transition: .5s
            cursor: pointer
            width: 100%
            &:hover
              color: $red
              .pin
                border-color: $red
            input[type="radio"]
              position: absolute
              left: 0
              top: 0
              height: 0
              width: 0
              display: none
              opacity: 0
              pointer-events: none
            .name
              min-width: rem(36)
            .pin
              height: rem(14)
              width: rem(14)
              border-radius: 0
              border: rem(1) solid #5C5C5C
              box-sizing: border-box
              transition: .5s
      &--zone
        +media((justify-content: (320: space-between, 442: flex-start, 768: space-between)))
      &--pressure
        .tooltip
          &__btn
            margin-left: rem(14)
            cursor: help
      .input
        background: #FFFFFF
        border: rem(1) solid $grey
        box-sizing: border-box
        border-radius: rem(4)
        font-family: $main-font
        min-width: rem(80)
        height: rem(34)
        font-style: normal
        font-weight: bold
        font-size: rem(18)
        line-height: rem(22)
        text-align: center
        outline: none
        transition: .5s
        margin-left: rem(17)
        margin-right: rem(10)
        align-items: center
        display: flex
        flex-direction: row
        justify-content: center
        cursor: default
      .tooltip
        &__btn
          line-height: 0
          cursor: help
    .divider
      background: #ECECEC
      pointer-events: none
      +media((width: (320: 100%, 768: rem(1))))
      +media((height: (320: rem(1), 768: rem(34))))
  &__types
    &-wrapper
      width: 100%
      display: grid
      grid-template-columns: repeat(3, 1fr)
      grid-column-gap: rem(5)
      +media((grid-template-columns: (320: 1fr, 768: repeat(3, 1fr))))
      +media((grid-row-gap: (320: rem(1), 992: rem(5))))
      +media((padding: (320: 0 rem(24), 992: 0 0 rem(51))))
      +media((margin-bottom: (320: rem(24), 992: 0)))
    &-item
      text-align: left
      display: flex
      background: rgba(255, 255, 255, 0.5)
      cursor: pointer
      transition: .5s
      position: relative
      border-radius: rem(4)
      +media((flex-wrap: (560: wrap, 768: unset)))
      +media((flex-direction: (320: column, 560: row, 768: column)))
      +media((padding: (320: rem(24) rem(26) rem(32))))
      &:hover
        background: #FFFFFF
        box-shadow: 0 rem(5) rem(20) rgba(51, 51, 51, 0.15), 0 rem(1) rem(4) rgba(51, 51, 51, 0.3)
        .location__types-item--name
          color: $red
        .location__types-item--img
          &:before
            +media((opacity: (320: 0, 768: 1)))
      &.active
        background: #FFFFFF
        box-shadow: 0 rem(5) rem(20) rgba(51, 51, 51, 0.15), 0 rem(1) rem(4) rgba(51, 51, 51, 0.3)
        .location__types-item--name
          color: $red
        .location__types-item--img
          &:before
            opacity: 1
      input[type="radio"]
        position: absolute
        left: 0
        top: 0
        height: 0
        width: 0
        display: none
        opacity: 0
        pointer-events: none
      &--img
        line-height: 0
        position: relative
        +media((width: (560: 50%, 768: 100%)))
        +media((order: (320: 2, 992: 1)))
        &:before
          background-image: url(../assets/img/tick.svg)
          content: ""
          position: absolute
          height: 100%
          width: 100%
          background-repeat: no-repeat
          background-position: center
          opacity: 0
          pointer-events: none
          transition: .5s
        img
          line-height: 0
          width: 100%
          border-radius: rem(2)
      &--name
        font-style: normal
        font-weight: bold
        font-size: rem(14)
        line-height: rem(18)
        text-transform: uppercase
        transition: .5s
        display: flex
        flex-direction: row
        align-items: center
        width: 100%
        +media((justify-content: (320: space-between, 992: flex-start)))
        +media((order: (320: 1, 960: 2)))
        +media((padding: (320: 0 0 rem(24), 960: rem(25) 0)))
        .btn
          background: $red
          color: #fff
          font-style: normal
          font-weight: 600
          font-size: rem(12)
          line-height: rem(16)
          text-transform: none
          border-radius: rem(4)
          height: 100%
          padding: rem(8) rem(25)
          transition: .5s
          +media((display: (320: block, 960: none)))
          img
            margin-right: rem(18)
          &.active
            background: rgba(46, 204, 113, 0.7)
            padding: rem(8) rem(19) rem(8) rem(14)
        &__h
          +media((display: (320: none, 400: contents, 768: none, 960: contents)))
      &--text
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(22)
        color: #5C5C5C
        order: 3
        +media((padding-left: (560: rem(30), 768: 0)))
        +media((width: (560: 50%, 768: 100%)))
        +media((padding-top: (320: rem(24), 560: 0, 768: rem(24), 960: 0)))
  &__coefficient
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    &-title
      display: flex
      flex-direction: row
      align-items: center
      font-style: normal
      font-weight: bold
      +media((font-size: (320: rem(16), 992: rem(18))))
      +media((line-height: (320: rem(26), 992: rem(22))))
      padding-bottom: 0
      color: $black
      text-align: left
      .tooltip__btn
        line-height: 0
        margin-left: rem(20)
        cursor: help
    &-input
      background: #FFFFFF
      border: rem(1) solid $grey
      box-sizing: border-box
      border-radius: rem(4)
      font-family: $main-font
      width: rem(80)
      height: rem(34)
      font-style: normal
      font-weight: bold
      font-size: rem(18)
      line-height: rem(22)
      text-align: center
      outline: none
      transition: .5s
      margin-left: rem(17)
      margin-right: rem(10)
      &:hover
        @extend .common__input-hover
  &__buttons
    &-nav
      justify-content: flex-end
</style>
